import React from 'react';

import { AboutUs, Founder, FindUs, Footer, Gallery, Header, Intro, Laurels, Products } from './container';
import { Navbar, ScrollUp } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <AboutUs />
    <Products />
    <Intro />
    <Founder />
    <Laurels />
    <Gallery />
    <FindUs />
    <Footer />
    <ScrollUp />
  </div>
);

export default App;
